<template>
  <div class="commodity-content">
    <div class="goods-swiper">
      <img :src="details.image" class="goods-img" alt />
    </div>
    <div class="goods-center">
      <div class="goods-data">
        <h3 class="name">
          {{ details.commodityName }}
        </h3>
        <div class="goods-line">
          拼单价:
          <p class="start-price">
            {{ $utils.emptyFormat(details.price) }}
          </p>
          <p>元/{{ details.measureUnit }}</p>
        </div>
        <div class="img-wrap">
          <img
            class="bid-img"
            :src="groupBuyImg.success"
            v-if="details.buttonStatus.winner"
            alt
          />
          <img
            class="bid-img"
            :src="groupBuyImg.failed"
            v-if="details.buttonStatus.failed"
            alt
          />
        </div>
      </div>
      <div class="goods-gaslng">
        <div class="name">
          <Cell title="销售方" :value="details.sellerName"></Cell>
          <Cell
            title="拼单总量"
            :value="details.totalWeight + details.measureUnit"
          ></Cell>
        </div>
        <div class="name">
          <Cell
            title="起拼量"
            :value="details.stratWeight + details.measureUnit"
          ></Cell>
          <Cell
            title="加量梯度"
            :value="details.weightGrade + details.measureUnit"
          ></Cell>
        </div>
        <div class="name">
          <Cell
            title="限拼量"
            :value="details.limitWeight + details.measureUnit"
          ></Cell>
          <Cell
            title="我的拼单"
            :value="details.myTradeWeight + details.measureUnit"
          ></Cell>
        </div>
      </div>
      <div class="goods-data mar-b-24">
        <div class="goods-line">
          <div class="count-dowm-wrap">
            <div v-if="details.status == '30'" class="count-down">
              距离开始：
              <van-count-down
                :time="details.validBeginTime - curTime"
                format="DD天HH小时mm分ss秒"
              />
            </div>
            <div v-if="details.status == '40'" class="count-down">
              距离结束：
              <van-count-down
                :time="details.finalEndTime - curTime"
                format="DD天HH小时mm分ss秒"
              />
            </div>
            <div v-if="/60|50/.test(details.status)" class="count-down">
              已结束：结束于
              {{ details.finalEndTime | dateFilter("time") }}
            </div>
          </div>
        </div>
      </div>
      <div class="goods-data">
        <BidList :titleFlag="false" :dataTable="dataTable"></BidList>
      </div>

      <div class="baise-info">
        <div class="baise-title">基本信息</div>
        <div class="baise-content">
          <div class="baise-line">
            <Cell title="销售方" :value="details.sellerName"></Cell>
            <Cell
              title="拼单单价"
              :value="details.price + '元/' + details.measureUnit"
            ></Cell>
          </div>
          <div class="baise-line">
            <Cell title="商品" :value="details.commodityName"></Cell>
            <Cell
              title="拼单总量"
              :value="details.totalWeight + details.measureUnit"
            ></Cell>
          </div>
          <div class="baise-line">
            <Cell
              title="起拼量"
              :value="details.stratWeight + details.measureUnit"
            ></Cell>
            <Cell
              title="限拼量"
              :value="details.limitWeight + details.measureUnit"
            ></Cell>
          </div>
          <div class="baise-line">
            <Cell
              title="加量梯度"
              :value="details.weightGrade + details.measureUnit"
            ></Cell>
            <Cell title="交货方式" :value="viewText.deliveryWay"></Cell>
          </div>
          <div class="baise-line">
            <Cell title="交货地点" :value="viewText.depositFlag"></Cell>
          </div>
          <div class="baise-line">
            <Cell
              title="开始时间"
              :value="details.validBeginTime | dateFilter('time')"
            ></Cell>
          </div>
          <div class="baise-line">
            <Cell
              title="结束时间"
              :value="details.validEndTime | dateFilter('time')"
            ></Cell>
          </div>
          <div class="baise-line">
            <Cell title="支付期限" :value="viewText.payDeadline"></Cell>
          </div>
        </div>
      </div>
      <div class="baise-info">
        <div class="baise-title">详情介绍</div>
        <div class="baise-content" v-html="commodityDetail"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Cell from "./Cell";
import { viewText, groupBuyImg } from "../group-buy-utils";

import BidList from "./BidList";
export default {
  name: "CommodityContent",
  components: {
    Cell,
    BidList,
  },
  props: {
    details: Object,
    commodityDetail: String,
    dataTable: Array,
  },
  data() {
    return {
      groupBuyImg: groupBuyImg,
      detailsIntroduction: "",
      LNGmaterialCode: this.$common.interfacePath.LngMaterialCode,
      PNGmaterialCode: this.$common.interfacePath.PngMaterialCode,
      swiperOption: {
        pagination: "swiper-pagination",
        loop: false,
        observer: true,
      },
    };
  },
  computed: {
    curTime() {
      return new Date().getTime();
    },
    viewText() {
      return viewText(this.details);
    },
  },
  methods: {},
};
</script>
<style lang="stylus" scoped>
.commodity-content {
  .goods-swiper {
    width: 100%;
    background: #ffffff;
    height: 450px;
    margin: 0 auto;
    position: relative;

    .van-swipe {
      width: 100%;
      height: 100%;
    }

    .goods-img {
      height: 100%;
      width: 100%;
    }

    .img-pagination {
      width: 10px;
      background: #333;
      color: #fff;
      opacity: 0.5;
      padding: 15px 0;
      border-radius: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 20px;
      right: 20px;
      z-index: 99;
    }
  }

  .goods-status {
    $statusColor = #F66A21;
    background: rgba(246, 106, 33, 0.2);
    display: flex;
    height: 73px;
    font-size: 26px;
    font-weight: 400;
    line-height: 73px;

    .status {
      width: 154px;
      background: $statusColor;
      opacity: 1;
      color: #FFFFFF;
      text-align: center;
    }

    .count-down {
      flex: 1;
      width: 156px;
      color: #F66A21;
      display: flex;
      align-items: center;

      .count-down-label {
        margin-left: 64px;
        margin-right: 5px;
      }

      .count-down-time {
        display: flex;
        align-items: center;

        .colon {
          display: inline-block;
          margin: 0 4px;
        }

        .block {
          display: inline-block;
          width: 35px;
          height: 37px;
          background: $statusColor;
          opacity: 1;
          border-radius: 4px;
          line-height: 37px;
          color: #FFFFFF;
          text-align: center;
        }
      }
    }
  }

  .status30 {
    $color = #F66A21;
    background: rgba(246, 106, 33, 0.2);

    .status {
      width: 154px;
      background: $color;
      opacity: 1;
      color: #FFFFFF;
      text-align: center;
    }

    .count-down {
      flex: 1;
      width: 156px;
      color: #F66A21;
      display: flex;
      align-items: center;

      .count-down-label {
        margin-left: 64px;
        margin-right: 5px;
      }

      .count-down-time {
        display: flex;
        align-items: center;

        .colon {
          display: inline-block;
          margin: 0 4px;
        }

        .block {
          display: inline-block;
          width: 35px;
          height: 37px;
          background: $statusColor;
          opacity: 1;
          border-radius: 4px;
          line-height: 37px;
          color: #FFFFFF;
          text-align: center;
        }
      }
    }
  }

  .status40 {
    background: rgba(251, 41, 34, 0.2);
    $statusColor = #FB2922;

    .status {
      width: 154px;
      background: $statusColor;
      opacity: 1;
      color: #FFFFFF;
      text-align: center;
    }

    .count-down {
      flex: 1;
      width: 156px;
      color: $statusColor;
      display: flex;
      align-items: center;

      .count-down-label {
        margin-left: 64px;
        margin-right: 5px;
      }

      .count-down-time {
        display: flex;
        align-items: center;

        .colon {
          display: inline-block;
          margin: 0 4px;
        }

        .block {
          display: inline-block;
          width: 35px;
          height: 37px;
          background: $statusColor;
          opacity: 1;
          border-radius: 4px;
          line-height: 37px;
          color: #FFFFFF;
          text-align: center;
        }
      }
    }
  }

  .status50 {
    background: rgba(130, 137, 153, 0.2);
    $statusColor = #828999;

    .status {
      width: 154px;
      background: $statusColor;
      opacity: 1;
      color: #FFFFFF;
      text-align: center;
    }

    .count-down {
      flex: 1;
      width: 156px;
      color: $statusColor;
      display: flex;
      align-items: center;

      .count-down-label {
        margin-left: 64px;
        margin-right: 5px;
      }

      .count-down-time {
        display: flex;
        align-items: center;

        p {
          width: 35px;
          height: 37px;
          background: $statusColor;
          opacity: 1;
          border-radius: 4px;
          line-height: 37px;
          color: #FFFFFF;
          text-align: center;
        }
      }
    }
  }

  .goods-center {
    .table {
      padding: 24px;
      background: #fff;
    }

    .introduce {
      padding: 24px;
      background: #fff;

      .title {
        padding-bottom: 24px;
        font-size: 30px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }

      .content {
        font-size: 26px;
        font-weight: 400;
        line-height: 37px;
        color: rgba(102, 102, 102, 1);
        word-break: break-all;
      }
    }

    .content-line {
      font-size: 24px;
      font-weight: 400;
      display: flex;
      align-items: center;
      height: 44px;
    }

    .goods-gaslng {
      margin-bottom: 24px;
      padding: 24px 16px 0 24px;
      background: #fff;

      .precursor {
        display: flex;
        justify-content: space-between;
        font-size: 26px;
        color: #FB2922;
        padding-bottom: 26px;
        padding-right: 20px;
      }

      .name {
        padding-bottom: 24px;
        display: flex;

        .radio-cell {
          display: flex;
          min-width: 50%;
          align-items: center;

          .title {
            min-width: 100px;
            font-size: 26px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            opacity: 1;
            text-align-last: justify;
            text-align: justify;
          }

          span {
            font-size: 30px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }

          .value {
            font-size: 26px;
            font-weight: 400;
            color: #333333;
            opacity: 1;
            padding-left: 12px;
          }

          .check-box {
            display: flex;
            font-size: 26px;
            font-weight: 400;
            color: #333333;
            opacity: 1;
            padding-left: 12px;

            .terminal {
              // width: 88px;
              height: 48px;
              text-align: center;
              line-height: 48px;
              background: rgba(248, 248, 248, 1);
              opacity: 1;
              border-radius: 4px;
              margin-left: 20px;
              padding: 0 8px;
            }

            .checked {
              background: rgba(255, 246, 246, 1);
              border: 1px solid rgba(225, 32, 32, 1);
              opacity: 1;
              border-radius: 4px;
              color: #E12020;
            }
          }
        }
      }
    }

    .baise-info {
      .baise-title {
        height: 80px;
        font-size: 28px;
        font-weight: 400;
        line-height: 80px;
        text-align: center;
      }

      .baise-content {
        padding: 20px;
        font-size: 28px;
        line-height: 38px;
        background: #fff;

        .baise-line {
          padding-bottom: 24px;
          display: flex;

          .radio-cell {
            display: flex;
            min-width: 50%;
            align-items: center;

            .title {
              min-width: 100px;
              font-size: 26px;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              opacity: 1;
              text-align-last: justify;
              text-align: justify;
            }

            span {
              font-size: 30px;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
            }

            .value {
              font-size: 26px;
              font-weight: 400;
              color: #333333;
              opacity: 1;
              padding-left: 12px;
            }

            .check-box {
              display: flex;
              font-size: 26px;
              font-weight: 400;
              color: #333333;
              opacity: 1;
              padding-left: 12px;

              .terminal {
                // width: 88px;
                height: 48px;
                text-align: center;
                line-height: 48px;
                background: rgba(248, 248, 248, 1);
                opacity: 1;
                border-radius: 4px;
                margin-left: 20px;
                padding: 0 8px;
              }

              .checked {
                background: rgba(255, 246, 246, 1);
                border: 1px solid rgba(225, 32, 32, 1);
                opacity: 1;
                border-radius: 4px;
                color: #E12020;
              }
            }
          }
        }
      }
    }

    .goods-data {
      background: #fff;
      padding: 0 24px;

      // margin-bottom: 24px;
      .img-wrap {
        position: relative;

        .bid-img {
          width: 122.47px;
          height: 122.47px;
          position: absolute;
          right: 20px;
          top: -130px;
        }
      }

      .goods-line {
        display: flex;
        align-items: center;
        height: 88px;
        font-size: 26px;
        font-weight: 400;
        line-height: 88px;
        color: rgba(51, 51, 51, 1);

        .location {
          .location-img {
            width: 19px;
            height: 24px;
          }
        }

        .count-down {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 33px;
          color: #333333;
          text-align: center;
        }

        .start-price {
          margin: 0 5px;
          color: rgba(225, 32, 32, 1);
          font-size: 36px;
          font-weight: bold;
        }

        p {
          display: flex;
          align-items: center;
        }
      }

      .space-between {
        display: flex;
        justify-content: space-between;
      }

      .price {
        font-size: 26px;
        font-weight: 400;
        line-height: 37px;
        color: rgba(51, 51, 51, 1);
        padding-bottom: 24px;

        span {
          color: rgba(225, 32, 32, 1);
          font-size: 36px;
        }
      }

      .name {
        display: flex;
        align-items: center;
        line-height: 44px;
        font-size: 32px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);

        span {
          display: inline-block;
          font-size: 12px;
          font-weight: bold;
          color: rgba(225, 32, 32, 1);
          padding: 0 15px;
          border: 1px solid rgba(225, 32, 32, 1);
          vertical-align: middle;
          margin-right: 6px;
          word-break: keep-all;
        }
      }

      .number {
        font-size: 26px;
        font-weight: 400;
        line-height: 37px;
        color: rgba(102, 102, 102, 1);
        display: flex;
        padding-bottom: 24px;

        span {
          color: rgba(225, 32, 32, 1);
          padding-left: 12px;
        }

        .unit {
          color: rgba(51, 51, 51, 1);
          padding-left: 0;
        }
      }
    }
  }
}

.mar-b-24 {
  margin-bottom: 24px;
}
</style>
